interface BlogCategory {
  id: number;
  name: string;
  slug: string;
}

interface BlogImage {
  id: number;
  alt: string;
  url: string;
  filename: string;
  mimeType: string;
  filesize: number;
  width: number;
  height: number;
}

interface PostBodyNode {
  type: string;
  children?: any[];
  text?: string;
  [key: string]: any;
}

interface PostBody {
  root: {
    type: string;
    children: PostBodyNode[];
  };
}

export interface FeaturedBlogPost {
  id: number;
  name: string;
  slug: string;
  mainImage: BlogImage;
  category: BlogCategory;
  date: string;
  readTime: string;
  postBody: PostBody;
}

export interface HomeFeaturedBlogsResponse {
  docs: FeaturedBlogPost[];
  totalDocs: number;
  limit: number;
  totalPages: number;
  page: number;
  pagingCounter: number;
  hasPrevPage: boolean;
  hasNextPage: boolean;
  prevPage: number | null;
  nextPage: number | null;
}

/**
 * Extract plain text from post body lexical structure
 * Limited to first 150 characters
 */
export const extractTextFromPostBody = (postBody: PostBody, maxLength = 150): string => {
  if (!postBody?.root?.children) return "";

  let text = "";

  const extractText = (nodes: PostBodyNode[]): void => {
    for (const node of nodes) {
      if (text.length >= maxLength) break;

      if (node.text) {
        text += node.text;
      }

      if (node.children && Array.isArray(node.children)) {
        extractText(node.children);
      }
    }
  };

  extractText(postBody.root.children);

  // Trim to max length and add ellipsis if needed
  if (text.length > maxLength) {
    text = `${text.substring(0, maxLength).trim()}...`;
  }

  return text;
};

/**
 * Format date to "MMM DD, YYYY" format
 */
export const formatBlogDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
  });
};
